export enum TaxIdStatusEnum {
    NONE = 0,
    YES = 1,
    NO = 2,
}